import React,{useEffect,useState,useContext} from 'react'
import axios from 'axios'
import { ManagerAuthContext } from "../context/AuthManager";
import { ToastContainer, toast } from "react-toastify";

export const MedicalCommandAdmin = () => {

    const { currentUserRF } = useContext(ManagerAuthContext);

    const [name,setName] = useState('')
    const [tokenid,settokenid] = useState('')
    const [father,setfather] = useState('')
    const [year,setYear] = useState('')
    const [month,setMonth] = useState('')
    const [day,setDay] = useState('')
    const [bah,setbah] = useState('')
    const [room,setroom] = useState('')
    const [doctor,setdoctor] = useState('')
    const [vu1,setvu1] = useState('')
    const [vu2,setvu2] = useState('')
    const [ta,setta] = useState('')
    const [tel,setTel] = useState('')

    const [names,setNames] = useState('')

 const RegisterMedical = async() =>{
   try{
        if(!bah || !room || !doctor || !vu1 || !vu2){
          toast.warning("لطفا تمامی موارد خواسته شده را پر نمائید")
        }else{         
      await axios.post("https://clinic.salamatpayanew.ir/MedicalCommand/MedicalRegiste",{
        tokenid:tokenid,
        name:names,
        father:father,
        day:day,
        month:month,
        year:year,
        bah:bah,
        room:room,
        ta:ta,
        doctor:doctor,
        vu1:vu1,
        vu2:vu2,
        tel:tel
        
      })
      toast.success("عملیات ثبت  با موفقیت انجام شد")
    }
    }catch(e){
      toast.error("خطا در ایجاد ثبت")
    }
  }

  const [userList, setUserList] = useState([]);

useEffect(() => {
  const getAllProductsRT = async () => {
    // personal Read
    const res = await fetch(
      'https://clinic.salamatpayanew.ir/MedicalCommand/MedicalList'
    );
    setUserList(await res.json());
  };
  getAllProductsRT();
}, []);

const ViewItem = (token,nameA,fatherA,dayA,monthA,yearA,baA,roomA,taA,doctorA,vu1A,vu2A) => {
    settokenid(token)
    setName(nameA)
    setfather(fatherA)
    setDay(dayA)
    setMonth(monthA)
    setYear(yearA)
    setbah(baA)
    setroom(roomA)
    setta(taA)
    setdoctor(doctorA)
    setvu1(vu1A)
    setvu2(vu2A)
}
const clearInput = () => {
    settokenid('')
    setName('')
    setfather('')
    setDay('')
    setMonth('')
    setYear('')
    setbah('')
    setroom('')
    setta('')
    setdoctor('')
    setvu1('')
    setvu2('')
}

const [cate, setCate] = useState([]);

useEffect(() => {
  
  const getAllProductsRFw = async () => {
    const res = await fetch(
      "https://clinic.salamatpayanew.ir/Register/UserList"
    );
    setCate(await res.clone().json());
  };
  getAllProductsRFw();
}, []);

const handleDelete = (id) => {
    axios
      .delete(
        `https://clinic.salamatpayanew.ir/MedicalCommand/DeleteMedical/${id}`
      )
      .then((response) => {
        setUserList((values) => {
          return values.filter((item) => item.id !== id);
        });

        toast.success("حذف  با موفقیت انجام شد");
      });
  };

  const [read,setRead] = useState([])

const unchange = async(telID) =>{
    const res = await fetch(
        `https://clinic.salamatpayanew.ir/Register/GetnameList/${telID}`
      );
      setRead(await res.clone().json());
  }

  const largest = () =>{
        read.map((sis) =>{
            setNames(sis.name)
        })
        toast.success("نام دانش آموز تایید شد")
  }

if (currentUserRF.meli === null) {
  } else {
 return (
   <>
     <section class="m-0 content" dir='rtl'>
        <div class="d-flex flex-column justify-content-start align-items-center">
            <div class="card">
                <img src="../img/dr02.png" class="position-absolute form-img" alt="" />
                <div class="d-flex flex-column justify-content-start card-title-container">
                    <div class="card-title text-secondary">دستورات پزشکی</div>
                    <p class="card-subtitle">ثبت دستورات پزشکی</p>
                </div>
                <div class="d-flex flex-column flex-md-row justify-content-between w-100 t-8">
                    <div class="custom-form-control form-group position-relative w-50 m-0 me-md-3">
                        <input type="text" class="form-control pr-16 my-2" placeholder="شماره پرونده" value={tokenid} onChange={(e) => settokenid(e.target.value)} />
                    </div>
                    <div class="custom-form-control form-group position-relative w-50 m-0 me-md-3">
                        <select
                              id="selce"
                              className="form-control pr-16 my-2"
                              onChange={(e) => setTel(e.target.value)}
                              onClick={(e) => unchange(tel)}
                            >
                              <option value={"دانش آموز انتخاب نشده"}>انتخاب دانش آموز</option>
                              {cate.map((item) => {
                                const {
                                    id,tel,name
                                    } = item;
                                return <option value={item.tel}>{item.name}</option>;
                              })}
                              
                    </select>
                        </div>
                <button class="custom-btn-primary  form-submit m-0 me-md-3 mt-2" onClick={largest}>
                    تایید
                </button>
                    <div class="custom-form-control form-group position-relative w-50 m-0 me-md-3">
                        <input type="text" class="form-control pr-16 my-2" placeholder="نام پدر" value={father} onChange={(e) => setfather(e.target.value)}/>
                    </div>
                    <div class="custom-form-control form-group position-relative w-10">
                            <input type="text" class="form-control pr-16 my-2" placeholder="روز" value={day}  onChange={(e) => setDay(e.target.value)}/>
                        </div>
                        <div class="custom-form-control form-group position-relative w-10">
                            <input type="text" class="form-control pr-16 my-2" placeholder="ماه" value={month} onChange={(e) => setMonth(e.target.value)}/>
                        </div>
                        <div class="custom-form-control form-group position-relative w-10">
                            <input type="text" class="form-control pr-16 my-2" placeholder="سال" value={year} onChange={(e) => setYear(e.target.value)}/>
                        </div>
                </div>
                <div class="d-flex flex-column flex-md-row justify-content-between w-100">
                    <div class="custom-form-control form-group position-relative w-50">
                        <input type="text" class="form-control pr-16 my-2" placeholder="نام بخش" value={bah} onChange={(e) => setbah(e.target.value)}/>
                    </div>
                    <div class="custom-form-control form-group position-relative w-50 m-0 mx-md-3">
                        <input type="text" class="form-control pr-16 my-2" placeholder="شماره اتاق" value={room} onChange={(e) => setroom(e.target.value)}/>
                    </div>
                    <div class="custom-form-control form-group position-relative w-50 m-0 me-md-3">
                        <input type="text" class="form-control pr-16 my-2" placeholder="تخت" value={ta} onChange={(e) => setta(e.target.value)}/>
                    </div>
                    <div class="custom-form-control form-group position-relative w-50">
                        <input type="text" class="form-control pr-16 my-2" placeholder="پزشک معالج" value={doctor} onChange={(e) => setdoctor(e.target.value)}/>
                    </div>
                </div>
                <div class="seprator my-24"></div>
                <div class="d-flex flex-column w-100" id="parent_medical">
                    <div class="d-flex flex-column flex-md-row justify-content-between w-100">
                        <div class="custom-form-control form-group position-relative w-25 priority m-0 me-md-3">
                            <div class="custom-form-control form-group position-relative">
                                <input type="text" class="form-control pr-16 my-2 flatpickr-datetime"
                                       placeholder="تاریخ و ساعت" value={vu1} onChange={(e) => setvu1(e.target.value)} />
                            </div>
                        </div>
                        <div class="custom-form-control form-group position-relative w-100">
                            <input type="text" class="form-control pr-16 my-2" placeholder="دستور برای اجرا" value={vu2} onChange={(e) => setvu2(e.target.value)}/>
                        </div>
                    </div>
                </div>
                <div className='container'>
                    <div className="row">
                <button class="custom-btn-primary t-24 form-submit p-16 ms-3" onClick={RegisterMedical}>
                    ثبت دستورات
                </button>
                <button class="custom-btn-primary t-24 form-submit p-16" onClick={clearInput}>
                    جدید
                </button>
                </div>
                </div>
            </div>
        </div>
    </section>

    <section class="m-0 content" dir='rtl'>
            <div class="row">
                <h1 class="page-title text-secondary text-start w-100">لیست ثبت سیر بیماری</h1>
                <div class="table-responsive">
                    <table class="table bg-white custom-rounded t-24 table-responsive">
                        <thead>
                            <tr class="text-center">
                            <th><span>شماره پرونده</span></th>
                               <th><span>نام</span></th>
                                <th><span>نام بخش</span></th>
                                <th><span>شماره اتاق</span></th>
                                <th><span>تخت</span></th>
                                <th><span>پزشک معالج</span></th>
                                <th><span>وضعیت</span></th>
                                <th><span>عملیات</span></th>
                                <th><span>حذف</span></th>
                            </tr>
                        </thead>
                        {userList.map((item) => {
                        const {
                          id,tokenid,name,father,day,month,year,bah,room,ta,doctor,vu1,vu2,stat
                        } = item;
                        return (
                        <tbody class="text-center" key={item.id}>
                            <tr>
                            <td>{item.tokenid}</td>
                                <td>{item.name}</td>
                                <td>
                                <div class="d-flex flex-column justify-content-start align-items-start mr-16 text-right">
                                       <p class="mb-0">{item.bah}</p>
                                 </div>
                                </td>
                                <td>{item.room}</td>
                                <td>{item.ta}</td>
                                <td>{item.doctor}</td>
                                <td><span class="tags">{item.stat}</span></td>
                                <td style={{cursor:'pointer',color:'blue'}} onClick={() => ViewItem(tokenid,name,father,day,month,year,bah,room,ta,doctor,vu1,vu2)}>نمایش جزئیات</td>
                                <td style={{cursor:'pointer',color:'red'}} onClick={() => handleDelete(id)}> حذف</td>
                            </tr>
                        </tbody>
                        );
                      })}
                    </table>

                </div>
            </div>
        </section>
    
    <ToastContainer
        position="top-center"
        autoClose={20000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
   </>
  )
 }
}
